import { useState } from "react";
import type { EqmsController } from "../../../controllers/useEqms";
import { useIssues } from "../../../controllers/useIssues";
import type { ProjectMember } from "../../../models/account";
import { WORK_AREA_SHORT_LABEL, hasDesignAndTest } from "../../../models/eqms";
import { IssuesView } from "../IssuesView";
import { EqmsDocumentsView } from "./EqmsDocumentsView";
import { EqmsDesignTestView } from "./EqmsDesignTestView";
import { EqmsTestCaseView } from "./EqmsTestCaseView";

type AreaTab = "issues" | "documents" | "design" | "test";
const TAB_LABEL: Record<AreaTab, string> = {
  issues: "이슈", documents: "문서", design: "설계", test: "테스트",
};

// eQMS 업무유형 섹션(QMS/SW/사이버보안/AI): 업무유형별 이슈 보드(GitHub-Projects 스타일)와 문서 목록을 보여주고,
// SW/사이버보안/AI는 설계·테스트 탭을 추가로 제공한다. 이슈는 프로젝트 전체를 로드해(useIssues, 서버 workArea
// 스코프 없이) IssuesView가 scope={{workArea}}로 클라이언트 필터링한다 — 이래야 하위이슈 진행률 롤업이 다른
// 업무유형의 자식까지 정확히 집계한다(서버 스코프면 과소집계).
export function EqmsWorkAreaView({ eqms, members }: { eqms: EqmsController; members: ProjectMember[] }) {
  const area = eqms.workArea;
  const issues = useIssues(eqms.projectId);
  const showDesignTest = area ? hasDesignAndTest(area) : false;
  const tabs: AreaTab[] = showDesignTest ? ["issues", "documents", "design", "test"] : ["issues", "documents"];
  const [tab, setTab] = useState<AreaTab>("issues");

  if (!eqms.projectId) return <div className="center">프로젝트를 선택하세요.</div>;
  if (!area) return <div className="center">업무유형을 선택하세요.</div>;

  const activeTab = tabs.includes(tab) ? tab : "issues";

  return (
    <div>
      <div style={{ marginBottom: 12 }}>
        <h2 style={{ margin: 0 }}>{WORK_AREA_SHORT_LABEL[area]}</h2>
        <div className="note" style={{ marginTop: 4 }}>업무유형별 이슈 · 문서</div>
      </div>

      <div className="tabs">
        {tabs.map((t) => (
          <button key={t} className={`tab ${activeTab === t ? "active" : ""}`} onClick={() => setTab(t)}>{TAB_LABEL[t]}</button>
        ))}
      </div>

      {activeTab === "issues" ? (
        <IssuesView issues={issues} members={members} scope={{ workArea: area }} />
      ) : activeTab === "documents" ? (
        <EqmsDocumentsView eqms={eqms} />
      ) : activeTab === "design" ? (
        <EqmsDesignTestView eqms={eqms} mode="design" />
      ) : (
        <EqmsTestCaseView eqms={eqms} />
      )}
    </div>
  );
}
